export const HARDCODE_PHARM_ID = 6;